// ============================================================
// FILE: resources/js/plugins/toast.js
// USPATIH GO — Toast Notification System (pesan aman ke user)
// ============================================================

import { resolveAndReportError, toUserFacingMessage } from '../helpers/userFacingError.js';

const ICONS = {
  success: '✅',
  error:   '❌',
  warning: '⚠️',
  info:    'ℹ️',
};

const COLORS = {
  success: 'bg-emerald-500',
  error:   'bg-red-500',
  warning: 'bg-yellow-500',
  info:    'bg-blue-500',
};

function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function createToastContainer() {
  const el = document.createElement('div');
  el.id = 'toast-container';
  el.className = 'fixed top-4 right-4 z-[9999] flex flex-col gap-2';
  document.body.appendChild(el);
  return el;
}

/**
 * Tampilkan toast. Untuk type error/warning, pesan teknis diganti yang ramah
 * dan detail dikirim ke laravel.log.
 *
 * @param {string|Error|object} message
 * @param {'success'|'error'|'warning'|'info'} type
 * @param {number} duration
 */
export function toast(message, type = 'info', duration = 3500) {
  let text = typeof message === 'string' ? message : String(message?.message || message || '');

  if (type === 'error') {
    text = resolveAndReportError(message, toUserFacingMessage(message));
  } else if (type === 'warning') {
    text = toUserFacingMessage(message, text || 'Mohon periksa kembali.');
  }

  const container = document.getElementById('toast-container') || createToastContainer();

  const el = document.createElement('div');
  el.className = `
    flex items-center gap-3 px-4 py-3.5 rounded-2xl text-white text-sm font-medium
    shadow-lg ${COLORS[type] || COLORS.info}
    transform translate-x-full transition-all duration-300 ease-out min-w-[280px] max-w-sm
  `;
  el.innerHTML = `
    <span class="text-base">${ICONS[type] || ICONS.info}</span>
    <span class="flex-1">${escapeHtml(text)}</span>
    <button type="button" aria-label="Tutup" class="opacity-75 hover:opacity-100 text-lg leading-none ml-1 toast-dismiss">×</button>
  `;
  el.querySelector('.toast-dismiss')?.addEventListener('click', () => el.remove());

  container.appendChild(el);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => el.classList.remove('translate-x-full'));
  });

  setTimeout(() => {
    el.classList.add('translate-x-full', 'opacity-0');
    setTimeout(() => el.remove(), 300);
  }, duration);
}

window.toast = toast;
window.toUserFacingMessage = toUserFacingMessage;
